import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hdbsPipe'
})
export class HdbsPipePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return null;
  }

}
